import { useQuestionnaireActions } from "../../features/questionnaire";
import { useCoverGeniusSeeMoreCoversState } from "../useCoverGeniusSeeMoreCoversState";
import { useEffect } from "react";
import type { QuestionProps } from "../../components/Questionnaire/Section/Question/types";
import { isQuestion } from "../../components/Questionnaire/Section/Question/types";

export const getVisibleQuestions = (allQuestions: QuestionProps[]) =>
  allQuestions.filter(isQuestion).filter(({ visible }) => visible);

export const getSuggestedQuestions = (allQuestions: QuestionProps[]) =>
  allQuestions.filter(isQuestion).filter(({ suggested }) => suggested);

export const useCoverGeniusSection = ({
  allQuestions,
}: {
  allQuestions: QuestionProps[];
}) => {
  const { setVisible, setHidden } = useQuestionnaireActions();
  const [_, seeMoreCovers] = useCoverGeniusSeeMoreCoversState();
  const visiblySuggestedQuestionNames = getVisibleQuestions(allQuestions).map(
    ({ name }) => name,
  );
  const visibleQuestions = getSuggestedQuestions(allQuestions).map(
    ({ name }) => name,
  );

  useEffect(() => {
    if (visiblySuggestedQuestionNames.length > 0) {
      setHidden(visibleQuestions);
      setVisible(visiblySuggestedQuestionNames);

      seeMoreCovers(
        visiblySuggestedQuestionNames.length < visibleQuestions.length,
      );
    } else {
      seeMoreCovers(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
